import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SupervisorHeaderComponent } from './pages/core/supervisor-header/supervisor-header/supervisor-header.component';
import { SpinnerComponent } from '../../../core/src/lib/components/spinner/spinner.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SupervisorHeaderComponent, SpinnerComponent],
  templateUrl: './app.component.html',
})
export class AppComponent {
  title = 'Supervisor';
}
